import { withErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'

import { SentryErrorPage } from '@/pages/error/SentryErrorPage.tsx'
import { TeamMessagesWithoutTeamPage } from '@/pages/messages/TeamMessagesWithoutTeamPage'

export const Route = createFileRoute('/dashboard/$regionId/messages/none')({
  component: withErrorBoundary(TeamMessagesWithoutTeamPage, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
})
